import * as React from 'react';
import { Box } from '@mui/material';
import { PALSelect } from './PALSelect';
import { PALInput } from './PALInput';
import { UnknownAction } from '@reduxjs/toolkit';
import { TabPanel } from '../../../../shared/components/tabPanel/index';
import { ActivityFactorPALSelectType } from '../../../../shared/shared.interfaces';

export const Tab2 = ({
  BMRVal,
  activityFactorPAL_Input,
  activityFactorPAL_Select,
  setActivityFactorPAL_Input,
  setActivityFactorPAL_Select
}: {
  BMRVal: number;
  activityFactorPAL_Select: ActivityFactorPALSelectType;
  activityFactorPAL_Input: { PALRatio: number; value: number };
  setActivityFactorPAL_Select: (
    val: ActivityFactorPALSelectType
  ) => UnknownAction;
  setActivityFactorPAL_Input: (val: {
    PALRatio: number;
    value: number;
  }) => UnknownAction;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        borderRadius: '0.9375rem',
        gap: '1.25rem',
        marginTop: '1.875rem',
        padding: '0 0.9375rem'
      }}
    >
      <TabPanel
        tabs={['SELECT', 'INPUT']}
        panelData={[
          <PALSelect
            key={0}
            BMRVal={BMRVal}
            activityFactorPAL_Select={activityFactorPAL_Select}
            setActivityFactorPAL_Select={setActivityFactorPAL_Select}
          />,
          <PALInput
            key={1}
            BMRVal={BMRVal}
            activityFactorPAL_Input={activityFactorPAL_Input}
            setActivityFactorPAL_Input={setActivityFactorPAL_Input}
          />
        ]}
        styleType="type1"
      ></TabPanel>
    </Box>
  );
};
